<template lang="pug">
  .details-wrapper
    .name
      DBLabel(title="nome do responsável:", :body="supervisor.name")
    .email
      DBLabel(title="email:", :body="supervisor.email")
    .companies
      PMultiSelect(
        v-model="companies"
        useCommon="companies"
        labelItem="name"
        title="locais de trabalho"
        :displayMode="true"
      )
    .groups
      PMultiSelect(
        v-model="groups"
        useCommon="userGroups"
        labelItem="name"
        title="grupo"
        :displayMode="true"
      )
    .employees
      PMultiSelect(
        v-model="employees"
        useCommon="employees"
        labelItem="name"
        title="empregados"
        :displayMode="true"
      )
    .employers
      PMultiSelect(
        v-model="employers"
        useCommon="employers"
        labelItem="name"
        title="empregador"
        :displayMode="true"
      )
    .phone1
      DBLabel(title="telefone 01:", :body="supervisor.phone")
    .phone2
      DBLabel(title="telefone 02:", :body="supervisor.cellPhone")

    .actions-buttons
      PButton(color="info", size="md", @click="editSupervisor" title="editar")
        .icon-ptt-icons-lapis

      PButton(color="danger", size="md", @click="removeSupervisor", :loading="removeLoading" title="excluir")
        .icon-ptt-icons-excluir

</template>

<script>
import DBLabel from 'src/common/SmartTable/DBLabel'

export default {
  name: 'SupervisorDetails',
  components: {DBLabel},
  props: {
    supervisor: {type: Object, required: true}
  },
  data () {
    return {
      companiesData: { selected: [] },
      groupData: { selected: [] },
      employeesData: { selected: [] },
      employersData: { selected: [] },
      removeLoading: false
    }
  },
  computed: {
    companies: {
      set (val) { this.companiesData = val },
      get () {
        return {
          selected: this.supervisor.companies
        }
      }
    },
    groups: {
      set (val) { this.groupData = val },
      get () {
        return {
          selected: this.supervisor.groups
        }
      }
    },
    employees: {
      set (val) { this.groupData = val },
      get () {
        return {
          selected: this.supervisor.employees
        }
      }
    },
    employers: {
      set (val) { this.groupData = val },
      get () {
        return {
          selected: this.supervisor.employers
        }
      }
    }
  },
  methods: {
    async removeSupervisor () {
      this.removeLoading = true
      try {
        const result = await this.$API.supervisor.remove({ id: this.supervisor.id })
        console.log(result)
      } catch (e) {
        console.log(e)
      }
      this.removeLoading = false
      this.$emit('reloadTable')
    },
    editSupervisor () {
      this.$router.push(`/supervisor/${this.supervisor.id}`)
    }
  }
}
</script>

<style scoped lang="scss">
.details-wrapper {
  height: 100%;
  position: relative;

  display: grid;
  grid-template-columns: 1fr 1fr;
  grid-template-rows: .5fr .5fr .5fr .5fr .5fr 1fr;
  grid-column-gap: 20px;
  grid-template-areas:
    "name name"
    "email email"
    "companies groups"
    "employees employers"
    "phone1 phone2"
    ". buttons";

  .name { grid-area: name }
  .email { grid-area: email }
  .companies { grid-area: companies }
  .groups { grid-area: groups }
  .employees { grid-area: employees }
  .employers { grid-area: employers }
  .phone1 { grid-area: phone1 }
  .phone2 { grid-area: phone2 }
  .actions-buttons {
    grid-area: buttons;
    justify-self: right;
    align-self: end;

    display: grid;
    grid-gap: 2px;
    grid-auto-flow: column;
  }
}
</style>
